import { createAction } from '@reduxjs/toolkit';

/** The pending row the operator picked, by its `key`. Sent by a thunk too, hence apart. */
export const putawayRowChosen = createAction('operatorPutaway/rowChosen');
